import React, { FC, useEffect, useState } from 'react';
import {
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
  Paper,
  TextField,
  Typography,
} from '@material-ui/core';
import { SubmitHandler, useForm } from 'react-hook-form';
import { AccessTime, Done, Error } from '@material-ui/icons';
import { useLocation } from 'react-router-dom';
import * as mobilbase from '../../api/mobilbase';
import { CheckoutLocationProps } from '../../routes/mobilbase';
import { CheckoutResult } from '../../api/mobilbase/models';
import APIRequest from '../../components/helpers/APIRequest';
import { trDateTime } from '../../utils/tr';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardTimePicker,
  DateTimePicker,
} from '@material-ui/pickers';
import moment from 'moment';
import 'moment/locale/da';
import daLocale from 'date-fns/locale/da';
import DateFnsUtils from '@date-io/date-fns';
import ErrorDialog from '../../components/dialogs/ErrorDialog';

moment.locale('da');

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(2),
    margin: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    //alignItems: 'center',
  },
  firstForm: {
    fontWeight: 'bold',
    marginBottom: '0px',
    margin: theme.spacing(2),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(6),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  spaceClass: {
    // the CSS class used for "Eller" bokses
    alignItems: 'center',
    alignSelf: 'center',
    fontWeight: 'bold',
    textAlign: 'center',
    margin: theme.spacing(1),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  forms: {
    marginBottom: '0px',
    textAlign: 'left',
    fontWeight: 'bold',
    margin: theme.spacing(1),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(6),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  grid: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(20),
  },
}));

type CheckoutAmountValues = {
  amount: number;
};

type CheckoutTimeValues = {
  date: string;
  time: string;
};

const Checkout: FC = () => {
  const classes = useStyles();
  const routeLocation = useLocation<CheckoutLocationProps>();
  const {
    selectedLocationName,
    selectedLocationId,
    selectedDeviceId,
    cardNumberData,
    cardNumberView,
    regNumber,
    ticket,
    checkoutTime,
  } = routeLocation.state ? routeLocation.state : new CheckoutLocationProps();
  const [isPending, setIsPending] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [runSubmitNow, setRunSubmitNow] = useState(false);
  const [runSubmitAmount, setRunSubmitAmount] = useState(false);
  const [runSubmitTime, setRunSubmitTime] = useState(false);
  const [amountFormData, setAmountFormData] = useState<CheckoutAmountValues>({
    amount: 0,
  });
  const [timeFormData, setTimeFormData] = useState<CheckoutTimeValues>({
    date: '',
    time: '',
  });
  const [data, setData] = useState<CheckoutResult>({ msg: '' });
  const [showMsg, setShowMsg] = useState(false);
  const [fromDate, setFromDate] = useState<Date | null>(new Date());
  const [fromTime, setFromTime] = useState<Date | null>(new Date());
  const [toTime, setToTime] = useState<Date | null>(new Date());
  const amountForm = useForm<CheckoutAmountValues>();
  const timeForm = useForm<CheckoutTimeValues>();
  const [open, setOpen] = React.useState(false);
  const [amountOpen, setAmountOpen] = React.useState(false);
  const [timeOpen, setTimeOpen] = React.useState(false);
  const [checkFormType, setCheckFormType] = useState('');
  const [dummyAmount, setDummyAmount] = useState('');
  const alertExplanationAlertText = 'Når du bekræfter, checkes parkanten ud.';
  const alertYesValue = 'Bekræft';
  const alertNoValue = 'Fortryd';
  const [errorOpen, setErrorOpen] = useState(false);




  useEffect(() => {
    if (showMsg) {
      if (data.msg) {
        setMessage(data.msg);
      }
    }
  }, [showMsg, data.msg]);

  const onNowSubmit = async () => {
    if (!isPending) {
      setShowMsg(true);
      setRunSubmitNow(true);
    }
  };

  function alertAccept() {
    if (checkFormType === 'checkOut') {
      onNowSubmit();
      handleAlertClose();
    }
  }

  function handleAlertOpen(formType: string) {
    setCheckFormType(formType);
    if (formType === 'checkOut') {
      setOpen(true);
    }
    if (formType === 'checkAmount') {
      setAmountOpen(true);
    }
    if (formType === 'checkTime') {
      setTimeOpen(true);
    }
  }

  const handleAlertClose = () => {
    setOpen(false);
    setAmountOpen(false);
    setTimeOpen(false);
  };

  const RequestNowSubmit = () => {
    return (
      <APIRequest<CheckoutResult>
        run={runSubmitNow}
        setRun={setRunSubmitNow}
        pending={isPending}
        setIsPending={setIsPending}
        req={() =>
          mobilbase.postCheckout({
            locationId: +selectedLocationId,
            deviceId: +selectedDeviceId,
            body: {
              type: 'Nu',
              cardNumber: cardNumberData,
              regNumber: regNumber,
              ticket: ticket,
              data: '',
            },
          })
        }
        setData={setData}
      />
    );
  };

  const onAmountSubmit: SubmitHandler<CheckoutAmountValues> = async (
    values
  ) => {
    if (!isPending) {
      setShowMsg(true);
      setAmountFormData({ amount: values.amount });
      setRunSubmitAmount(true);
    }
  };

  const RequestAmountSubmit = () => {
    return (
      <APIRequest<CheckoutResult>
        run={runSubmitAmount}
        setRun={setRunSubmitAmount}
        pending={isPending}
        setIsPending={setIsPending}
        req={() =>
          mobilbase.postCheckout({
            locationId: +selectedLocationId,
            deviceId: +selectedDeviceId,
            body: {
              type: 'Amount',
              cardNumber: cardNumberData,
              regNumber: regNumber,
              ticket: ticket,
              data: '' + amountFormData.amount,
            },
          })
        }
        setData={setData}
      />
    );
  };

  const onTimeSubmit: SubmitHandler<CheckoutTimeValues> = async (values) => {
    if (!isPending) {
      setShowMsg(true);
      //setTimeFormData({date: values.date, time: values.time});
      setRunSubmitTime(true);
    }
  };

  const RequestTimeSubmit = () => {
    return (
      <APIRequest<CheckoutResult>
        run={runSubmitTime}
        setRun={setRunSubmitTime}
        pending={isPending}
        setIsPending={setIsPending}
        req={() =>
          mobilbase.postCheckout({
            locationId: +selectedLocationId,
            deviceId: +selectedDeviceId,
            body: {
              type: 'Time',
              cardNumber: cardNumberData,
              regNumber: regNumber,
              ticket: ticket,
              data: timeFormData.date + ' ' + timeFormData.time,
            },
          })
        }
        setData={setData}
      />
    );
  };

  const handleClose = () => {
    setData({ msg: '' });
    setShowMsg(false);
    setMessage('');
    setError('');
  };

  function showZerosMinutes(dt: any) {
    return (dt.getMinutes() < 10 ? '0' : '') + dt.getMinutes();
  }

  function showZerosHours(dt: any) {
    return (dt.getHours() < 10 ? '0' : '') + dt.getHours();
  }

  useEffect(() => {
    let now = new Date();
    let newTimeFormData = timeFormData;
    var newDateOptions : any = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
}
    const fullDate = fromDate?.toLocaleDateString('da-DK', newDateOptions);
    console.log(fullDate);
    let sameDayOrBigger: Boolean = false;
    let inCheckDay: Boolean = false;
    const checkinDateWithoutTime = new Date(checkoutTime);
    checkinDateWithoutTime.setHours(0, 0, 0, 0);
    const checkinTime = new Date(checkoutTime);

    const nowWithoutDate = new Date();
    nowWithoutDate.setHours(now.getHours(), now.getMinutes(), 0, 0);



    if(fromDate != null)
    {

      const fromDateWithoutTime = new Date(fromDate);
      fromDateWithoutTime.setHours(0, 0, 0, 0);
  
      const nowWithoutTime = new Date();
      nowWithoutTime.setHours(0, 0, 0, 0);

  
      if (fromDateWithoutTime >= nowWithoutTime) 
      {
        sameDayOrBigger = true;
      }

      if (+fromDateWithoutTime === +checkinDateWithoutTime) 
      {
        inCheckDay = true;
      }
      if (fromDate !== null && fromDate > now || fromDate !== null && fromDate < checkinDateWithoutTime) {
        setErrorOpen(true);
        setFromDate(now);
      }
    }

    if(fromTime != null)
    {
      
      const fromTimeWithoutDate = new Date();
      fromTimeWithoutDate.setHours(fromTime.getHours(), fromTime.getMinutes(), 0, 0);

      const checkinTimeWithoutDate = new Date();
      checkinTimeWithoutDate.setHours(checkinTime.getHours(), checkinTime.getMinutes(), 0, 0);


      if (fromTime > now && sameDayOrBigger === true || fromTimeWithoutDate < checkinTimeWithoutDate && inCheckDay) {
        setErrorOpen(true);
        newTimeFormData.date = fullDate + '';
        if(nowWithoutDate < checkinTimeWithoutDate && inCheckDay)
        {
          newTimeFormData.time = showZerosHours(checkinTime) + ':' + showZerosMinutes(checkinTime);
          setFromTime(checkinTime);
          return setTimeFormData(newTimeFormData);
        }
        else {
          newTimeFormData.time = showZerosHours(now) + ':' + showZerosMinutes(now);
          setFromTime(now);
          return setTimeFormData(newTimeFormData);
        }
      } else {
        newTimeFormData.date = fullDate + '';
        newTimeFormData.time =
          showZerosHours(fromTime) + ':' + showZerosMinutes(fromTime);
        return setTimeFormData(newTimeFormData);
      }
    }

  }, [fromDate, fromTime, timeFormData]);

  return (
    <Container maxWidth={false}>
      <RequestTimeSubmit />
      <RequestAmountSubmit />
      <RequestNowSubmit />
      <div className={classes.paper}>
        <Typography component="h1" variant="h5">
          <div style={{ float: 'left' }}>Manuel udcheckning: </div>
          <div style={{ float: 'right' }}>
            {selectedLocationName ? selectedLocationName : 'INGEN VALGT'}
          </div>
        </Typography>
        <div className={classes.paper}>
          <Typography component="h2" variant="h5">
            <div style={{ float: 'left' }}>Indcheckningsnummer:</div>
            <div style={{ float: 'right' }}>{ticket ? ticket : ''}</div>
          </Typography>
          <Typography component="h2" variant="h5">
            <div style={{ float: 'left' }}>Registreringsnummer:</div>
            <div style={{ float: 'right' }}>{regNumber ? regNumber : ''}</div>
          </Typography>
          <Typography component="h2" variant="h5">
            <div style={{ float: 'left' }}>Kortnummer:</div>
            <div style={{ float: 'right' }}>
              {cardNumberView ? cardNumberView : ''}
            </div>
          </Typography>
          <Typography component="h2" variant="h5">
            <div style={{ float: 'left' }}>Indcheckningstidspunkt:</div>
            <div style={{ float: 'right' }}>
              {' '}
              {checkoutTime ? trDateTime(checkoutTime) : ''}
            </div>
          </Typography>
        </div>
        <div>
          <MuiPickersUtilsProvider locale={daLocale} utils={DateFnsUtils}>
            <Paper elevation={6} className={classes.firstForm}>
              <Button
                onClick={() => {
                  handleAlertOpen('checkOut');
                  setToTime(new Date());
                }}
                fullWidth
                variant="contained"
                color="primary"
              >
                Check ud nu
              </Button>
              <div>
                <br />
                *OBS Dette checker parkanten ud til gældende tidspunkt:{' '}
                {showZerosHours(toTime)}:{showZerosMinutes(toTime)}{' '}
              </div>
            </Paper>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              className={classes.spaceClass}
            >
              <Paper
                style={{ width: '25%' }}
                elevation={6}
                className={classes.spaceClass}
              >
                Eller
              </Paper>
            </div>
            <Paper elevation={3} className={classes.forms}>
              <form
                id="amountFormId"
                noValidate
                onSubmit={amountForm.handleSubmit(onAmountSubmit)}
              >
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="amount"
                  label="Beløb"
                  value={dummyAmount}
                  onChange={(e) => setDummyAmount(e.target.value)}
                  name="amount"
                  autoComplete="amount"
                  autoFocus
                  inputRef={amountForm.register({
                    required: true,
                    minLength: 1,
                    pattern: /^[0-9]+$/i,
                  })}
                  error={amountForm.errors.amount ? true : false}
                />
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    handleAlertOpen('checkAmount');
                  }}
                >
                  Angiv beløb
                </Button>
              </form>
              <div>
                <br />
                *OBS Dette checker parkanten ud til angivet beløb. (F.eks: 300
                kr){' '}
              </div>
            </Paper>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              className={classes.spaceClass}
            >
              <Paper
                style={{ width: '25%' }}
                elevation={6}
                className={classes.spaceClass}
              >
                Eller
              </Paper>
            </div>
            <Paper elevation={3} className={classes.forms}>
              <form
                id="timeFormId"
                noValidate
                onSubmit={timeForm.handleSubmit(onTimeSubmit)}
              >
                <div style={{ margin: '10px' }}>
                  <KeyboardDatePicker
                    fullWidth
                    disableToolbar
                    variant="inline"
                    inputVariant="outlined"
                    format="dd-MM-yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="Dato"
                    value={fromDate}
                    onChange={setFromDate}
                    KeyboardButtonProps={{ 'aria-label': 'Set dato' }}
                  />
                  <KeyboardTimePicker
                    onClick={() => {}}
                    fullWidth
                    disableToolbar
                    variant="inline"
                    ampm={false}
                    keyboardIcon={<AccessTime />}
                    inputVariant="outlined"
                    format="HH:mm"
                    margin="normal"
                    id="time-picker-inline"
                    label="Tidspunkt"
                    value={fromTime}
                    onChange={setFromTime}
                    KeyboardButtonProps={{ 'aria-label': 'Set time' }}
                    autoOk={true}
                  />
                </div>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    handleAlertOpen('checkTime');
                  }}
                >
                  Angiv tidspunkt
                </Button>
              </form>
              <div>
                <br />
                *OBS Dette checker parkanten ud til angivet tidspunkt. (F.eks:
                21-07-09 klokken 08:00)
              </div>
            </Paper>
          </MuiPickersUtilsProvider>
        </div>
      </div>
      <Dialog
        open={(isPending && showMsg) || !!message || !!error}
        //onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Udcheckning i gang'}
        </DialogTitle>
        <DialogContent>
          {isPending && <CircularProgress />}
          {message && (
            <DialogContentText id="alert-dialog-description">
              <Done />
              {message ? message : ''}
            </DialogContentText>
          )}
          {error && (
            <DialogContentText id="alert-dialog-description">
              <Error />
              {error ? error : ''}
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Luk
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        id="firstCheckOut"
        title="Dialog for amount submit"
        open={open}
        onClose={handleAlertClose}
      >
        <DialogTitle id="alertDescription">
          {'Bekræft manuel udcheckning til nu: kl.'} {showZerosHours(toTime)}:
          {showZerosMinutes(toTime)}{' '}
        </DialogTitle>
        <DialogContent>{alertExplanationAlertText}</DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              alertAccept();
              {
                handleAlertClose();
              }
            }}
            color="primary"
            type="submit"
          >
            {alertYesValue}
          </Button>
          <Button onClick={handleAlertClose} color="primary" autoFocus>
            {alertNoValue}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        title="Dialog for amount submit"
        open={amountOpen}
        onClose={handleAlertClose}
      >
        <DialogTitle id="alertDescription">
          {'Bekræft manuel udcheckning til '} {dummyAmount}
          {' kr'}{' '}
        </DialogTitle>
        <DialogContent>{alertExplanationAlertText}</DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleAlertClose();
            }}
            color="primary"
            type="submit"
            form="amountFormId"
          >
            {alertYesValue}
          </Button>
          <Button onClick={handleAlertClose} color="primary" autoFocus>
            {alertNoValue}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        title="Dialog for time submit"
        open={timeOpen}
        onClose={handleAlertClose}
      >
        <DialogTitle id="alertDescription">
          {'Bekræft manuel udcheckning til '} {timeFormData.date} kl:{' '}
          {timeFormData.time}{' '}
        </DialogTitle>
        <DialogContent>{alertExplanationAlertText}</DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleAlertClose();
            }}
            color="primary"
            type="submit"
            form="timeFormId"
          >
            {alertYesValue}
          </Button>
          <Button onClick={handleAlertClose} color="primary" autoFocus>
            {alertNoValue}
          </Button>
        </DialogActions>
      </Dialog>
      <ErrorDialog
        open={errorOpen}
        onClose={function (): void {
          setErrorOpen(false);
        }}
        title={'Forkert input'}
        text={'Tidspunkt er ugyldig'}
      />
    </Container>
  );
};

export default Checkout;
